// runtime-cache.js - bounded per-frame image/profile caches for overlays.

const MAX_CACHE_ENTRIES = 50;
const _PHOTO_MISS = Symbol('no-photo');
const _logoCache = new Map();
const _playerPhotoCache = new Map();
const _playerProfileCache = new Map();

function setBounded(cache, key, value) {
  if (cache.has(key)) cache.delete(key);
  cache.set(key, value);
  while (cache.size > MAX_CACHE_ENTRIES) {
    cache.delete(cache.keys().next().value);
  }
}

export function getCachedLogo(url) {
  if (!url) return null;
  const cached = _logoCache.get(url);
  if (cached) {
    setBounded(_logoCache, url, cached);
    return cached.complete && cached.naturalWidth > 0 ? cached : null;
  }
  const img = new Image();
  img.src = url;
  setBounded(_logoCache, url, img);
  return null;
}

export function getCachedPlayerProfile(playerName) {
  if (!playerName) return null;
  const key = String(playerName).trim();
  if (_playerProfileCache.has(key)) {
    const cached = _playerProfileCache.get(key);
    setBounded(_playerProfileCache, key, cached);
    return cached === _PHOTO_MISS ? null : cached;
  }

  let player = null;
  try {
    const registry = JSON.parse(localStorage.getItem('cs_player_registry') || '{}');
    player = Object.values(registry).find(
      item => item.displayName === key || item.username === key
    ) || null;
  } catch (_) {}
  setBounded(_playerProfileCache, key, player || _PHOTO_MISS);
  return player;
}

export function getCachedPlayerPhoto(playerName) {
  if (!playerName) return null;
  const key = String(playerName).trim();
  const cached = _playerPhotoCache.get(key);
  if (cached === _PHOTO_MISS) return null;
  if (cached) {
    setBounded(_playerPhotoCache, key, cached);
    return cached.complete && cached.naturalWidth > 0 ? cached : null;
  }

  const player = getCachedPlayerProfile(key);
  if (player?.photo) {
    const img = new Image();
    img.src = player.photo;
    setBounded(_playerPhotoCache, key, img);
    return null;
  }

  setBounded(_playerPhotoCache, key, _PHOTO_MISS);
  return null;
}

export function clearImageCache() {
  _logoCache.clear();
  _playerPhotoCache.clear();
  _playerProfileCache.clear();
}
